/*@flow*/
import history from 'lib/history';
import getToken from 'lib/getToken';
import pluralize from 'pluralize';
import * as I from 'immutable';
import $ from 'jquery';

let cache = I.Map();

const fetchResults = ({
  resourceName,
  update,
  ...payload
}: {
  resourceName: string,
  page: number,
  per: number,
  sorted: Object[],
  filtered: Object[],
  update: Function,
}) => {
  history.updateQuery(payload);

  let params = $.param(payload);
  let cacheKey = resourceName + '|' + $.param(payload);

  const cachedItem = cache.get(cacheKey);
  if (cache.has(cacheKey) && cachedItem) {
    return Promise.resolve(cachedItem);
  }

  update({ loading: true });

  const pluralResource = pluralize(resourceName);
  const base = `/${pluralResource}.json`;
  return fetch(base + `?${params}`, {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': getToken(),
    credentials: 'same-origin',
  })
    .then(res => res.json())
    .then(res => {
      cache = cache.set(cacheKey, res);
      return res;
    });
};

export default ({
  update,
  resourceName,
}: {
  update: Function,
  resourceName: string,
}): ((
  {filtered: Array<any>, page: number, pageSize: number, sorted: Array<any>, ...}
) => Promise<void>) => ({
  page,
  pageSize,
  sorted,
  filtered,
}: {
  page: number,
  pageSize: number,
  sorted: Object[],
  filtered: Object[],
}) => {
  const payload = {
    resourceName,
    update,
    page,
    per: pageSize,
    sorted,
    filtered,
  };

  const pluralResource = pluralize(resourceName);

  return fetchResults(payload).then(res => {
    if (!res.meta) {
      const msg = `Cannot parse server result: ${JSON.stringify(res)}`;
      throw new Error(msg);
    }

    update({
      data: res[pluralResource],
      numPages: res.meta.total_pages,
      numRecords: res.meta.total_records,
      loading: false,
    });
  });
};
